import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsWhichProducesResourceIdAvailable } from "../selectors/selectBuildingsWhichProducesResourceIdAvailable";
import { createPathSelectBuildingMaxLevel } from "./createPathSelectBuildingMaxLevel";
export var pathSelectBuildingNotProducingMaxLevelByResourceId = function (action, state$, deps) {
    return createPathSelectBuildingMaxLevel(function () {
        var state = state$.value;
        var resourceId = action.taskType.resourceId;
        var availableBuildings = selectBuildingsWhichProducesResourceIdAvailable(state, resourceId);
        return availableBuildings.filter(utilBuildings.isNotProducing);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathSelectBuildingNotProducingMaxLevelByResourceId.ts
// module id = 901
// module chunks = 3